/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  document.addEventListener("DOMContentLoaded", function () {
    var sliders = document.querySelectorAll(".tabs-collections .tab-content .grid--mobile-slider");
    var arrowHidden = false;

    function hideAllArrows() {
      if (arrowHidden) return;
      arrowHidden = true;
      sliders.forEach(function(slider) {
        slider.classList.remove("show-arrow");
        slider.classList.add("hide-arrow");
      });
    }

    sliders.forEach(function(slider) {
      if (!arrowHidden) {
        slider.classList.add("show-arrow");
      }

      slider.addEventListener("scroll", hideAllArrows, { once: true });

      if (typeof Flickity !== "undefined") {
        var flkty = Flickity.data(slider);
        if (flkty) {
          flkty.on("dragStart", hideAllArrows);
        }
      }
    });
  });

  /* Hide Silver option */
document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(
    '.selector-wrapper[data-option-name="choose your option"]'
  );
  if (!wrapper) return;

  const sterlingInput = wrapper.querySelector('input[value="Sterling silver"]');
  if (!sterlingInput) return;

  const label = wrapper.querySelector(`label[for="${sterlingInput.id}"]`);
  if (label) label.click();

  wrapper.classList.add('silver-option');
  wrapper.style.display = 'none';
});
  /* end Hide Silver option */


  const material1 = document.querySelector('li[data-block-name="Materials-1"]');
  const material2 = document.querySelector('li[data-block-name="Materials-2"]');
  const descriptionTab = document.querySelector('li.tab-link-0');

  if (material2) {
    material2.style.display = "none";
  }

  function toggleMaterials() {
    const selected = document.querySelector(
      'input[name^="options[Choose your option]"]:checked'
    );

    if (!selected || !material1 || !material2) return;

    if (selected.value === "Sterling silver") {
      material1.style.display = "";
      material2.style.display = "none";
    } else {
      material1.style.display = "none";
      material2.style.display = "";
    }

    const currentTab = document.querySelector('.product-tabs-title .tab-link.current');

    if (
      currentTab &&
      (currentTab.dataset.blockName === "Materials-1" ||
       currentTab.dataset.blockName === "Materials-2")
    ) {
      descriptionTab.click();
    }
  }

  toggleMaterials();

  document.querySelectorAll(
    'input[name^="options[Choose your option]"]'
  ).forEach(function (radio) {
    radio.addEventListener('change', toggleMaterials);
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

